<template>
  <div>
    <section-header heading="2" ja="アプリをアンインストールしたら、保存したプリも消える？"/>
    <div class="textArea">
      <p>アプリをアンインストールした場合でも、改めて「プリクラON」アプリをインストール、またはWeb版「プリクラON」で同じアカウントでログインしていただければ、アルバムでプリを見ることができます。</p>
    </div>
    <sub-btn @click="onAboutWeb()">プリクラONについてに戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import SubBtn from '@/components/SubBtn.vue'

export default {
  name: "AboutWeb01",
  components: {
    SectionHeader,
    SubBtn
  },
  methods: {
    onAboutWeb() {
      this.$router.push("/AppaboutWeb")
    }
  }
}
</script>

<style lang="scss" scoped>
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  p {
    margin-top: 1em;
  }
}
</style>
